import uuidv4 from "uuid/v4";

export const analyticsProperties = {
	fingerprint: uuidv4(),
	ux: "recordings",
	feature: "meeting_recorder",
};
